"use strict";

exports.__esModule = true;
exports.getYear = exports.getWeek = exports.getQuarterRange = exports.getMonth = exports.getHourByDay = exports.getHour = exports.getFormattedDateBasedOnGrouping = exports.getDay = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getMonth = exports.getMonth = function getMonth(date) {
  return (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().format("MMM YYYY");
};
var getDay = exports.getDay = function getDay(date) {
  return (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().format("MMM D");
};
var getWeek = exports.getWeek = function getWeek(date) {
  return (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().format("MMM D YYYY");
};
var getHour = exports.getHour = function getHour(hour) {
  return Number(hour) >= 0 && Number(hour) < 10 ? "0" + hour + ":00" : hour + ":00";
};
var getHourByDay = exports.getHourByDay = function getHourByDay(date) {
  return (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().format("hh:mm, D MMM");
};
var getQuarterRange = exports.getQuarterRange = function getQuarterRange(date) {
  var start = (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().startOf("quarter");
  var end = (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().endOf("quarter");
  return start.format("MMM") + "-" + end.format("MMM YYYY");
};
var getYear = exports.getYear = function getYear(date) {
  return (0, _moment["default"])(date, _moment["default"].ISO_8601).utc().year();
};
var getFormattedDateBasedOnGrouping = exports.getFormattedDateBasedOnGrouping = function getFormattedDateBasedOnGrouping(date, grouping) {
  switch (grouping) {
    case "day":
      return getDay(date);
    case "week":
      return getWeek(date);
    case "month":
      return getMonth(date);
    case "quarter":
      return getQuarterRange(date);
    case "year":
      return getYear(date);
    case "hour":
      return getHour(date);
    case "hour-day":
      return getHourByDay(date);
    default:
      return date;
  }
};